export enum InternalNumberStatus {
    ACTIVE = "Активный",
    DISABLED = "Отключенный",
    REMOVED = "Удаленный"
}
